import { render, staticRenderFns } from "./ConfigSidebar.vue?vue&type=template&id=9fa471d0&scoped=true"
import script from "./ConfigSidebar.vue?vue&type=script&lang=js"
export * from "./ConfigSidebar.vue?vue&type=script&lang=js"
import style0 from "./ConfigSidebar.vue?vue&type=style&index=0&id=9fa471d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa471d0",
  null
  
)

export default component.exports